import { queryOptions, type QueryClient } from "@tanstack/react-query";
import { authClient } from "./auth";

/** Cached session for route guards, so navigating inside /app doesn't refetch on every click. */
export const sessionQuery = queryOptions({
  queryKey: ["session"],
  queryFn: async () => (await authClient.getSession()).data ?? null,
  staleTime: 60_000,
});

/**
 * After sign-in/out. Route guards use `ensureQueryData`, which happily returns a
 * stale cached `null` — so the old value must be *removed* and the new one
 * fetched before navigating, not merely invalidated.
 */
export async function refreshSession(qc: QueryClient) {
  qc.removeQueries({ queryKey: ["session"] });
  await qc.fetchQuery(sessionQuery);
  await qc.invalidateQueries({ queryKey: ["me"] });
}
